import React, { useEffect, useRef, useState } from "react";
import "./ChatActions.scss";

import copyIcon from "./img/copy.png";
import deleteIcon from "./img/delete.png";
import editIcon from "./img/edit.png";

const ChatActions = ({
  open,
  x,
  y,
  msg,
  isOwn,
  canEdit,
  onEdit,
  onCopy,
  onUnsend,
  onClose,
  canReply = false,
  onReply,
  canReact = false,
  hasHeart = false,
  onToggleHeart,
}) => {
  const ref = useRef(null);

  const [visible, setVisible] = useState(open);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (open) {
      setVisible(true);
      setClosing(false);
    } else if (visible) {
      setClosing(true);
      const t = setTimeout(() => {
        setVisible(false);
        setClosing(false);
      }, 230);
      return () => clearTimeout(t);
    }
  }, [open, visible]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose?.();
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("touchstart", onClickOutside);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("touchstart", onClickOutside);
    };
  }, [open, onClose]);

  if (!visible || !msg) return null;

  const vpW = typeof window !== "undefined" ? window.innerWidth : 0;
  const vpH = typeof window !== "undefined" ? window.innerHeight : 0;
  const approxWidth = 260;
  const approxHeight = 220;

  const safeLeft =
    vpW > 0
      ? Math.min(Math.max(8, x), Math.max(8, vpW - approxWidth - 8))
      : Math.max(8, x);
  const safeTop =
    vpH > 0
      ? Math.min(Math.max(8, y), Math.max(8, vpH - approxHeight - 8))
      : Math.max(8, y);

  const style = { left: safeLeft, top: safeTop };

  const cls =
    "chat-menu " + (closing ? "chat-menu--closing" : "chat-menu--opening");

  return (
    <div className={cls} style={style} ref={ref} role="menu">
      {canReply && (
        <button
          className="chat-menu__item"
          onClick={() => {
            onReply?.(msg);
          }}
        >
          <span className="chat-menu__icon-wrap chat-menu__emoji" aria-hidden="true">↩️</span>
          <span className="chat-menu__label">Відповісти</span>
        </button>
      )}

      {canReact && (
        <button
          className="chat-menu__item"
          onClick={() => {
            onToggleHeart?.(msg, !hasHeart);
          }}
        >
          <span className="chat-menu__icon-wrap chat-menu__emoji" aria-hidden="true">❤️</span>
          <span className="chat-menu__label">{hasHeart ? "Прибрати ❤️" : "Вподобати ❤️"}</span>
        </button>
      )}

      {(msg.text || msg.type === "image") && (
        <button
          className="chat-menu__item"
          onClick={() => {
            onCopy?.(msg);
            onClose?.();
          }}
        >
          <span className="chat-menu__icon-wrap">
            <img
              src={copyIcon}
              alt=""
              className="chat-menu__icon chat-menu__icon--invert"
            />
          </span>
          <span className="chat-menu__label">Копіювати</span>
        </button>
      )}

      {isOwn && canEdit && (
        <button
          className="chat-menu__item"
          onClick={() => {
            onEdit?.(msg);
          }}
        >
          <span className="chat-menu__icon-wrap">
            <img
              src={editIcon}
              alt=""
              className="chat-menu__icon chat-menu__icon--invert"
            />
          </span>
          <span className="chat-menu__label">Редагувати</span>
        </button>
      )}

      {isOwn && (
        <button
          className="chat-menu__item danger"
          onClick={() => {
            onUnsend?.(msg);
          }}
        >
          <span className="chat-menu__icon-wrap">
            <img src={deleteIcon} alt="" className="chat-menu__icon" />
          </span>
          <span className="chat-menu__label">Скасувати надсилання</span>
        </button>
      )}
    </div>
  );
};

export default ChatActions;
